module.exports = __webpack_public_path__ + "img/MO.c5a765c6.png";